import type { CSSProperties } from 'react'
import { useMemo } from 'react'

export const useElementRootStyles = (...styles: (Partial<CSSProperties> | undefined)[]) =>
  useMemo(() => {
    const mergedStyles = styles.reduce((acc, item) => ({ ...acc, ...item }), {})

    return mergedStyles
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...styles])
